import React from 'react';
import cn from 'classnames';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { useReadOnly } from '../../../contexts/ReadOnlyContext';

const log = new Logger('MANUAL_DOCUMENTS_BUTTON', LOG_LEVELS.DEBUG);

function ManualDocumentsButton (props) {
    log.debug('ManualDocumentsButton() :', props);
    const { isReadOnly } = useReadOnly();
    
    // Button is disabled if either props.disabled is true OR user has read-only role
    const isDisabled = props.disabled || isReadOnly;
    
    // Determine onClick handler based on disabled state and prop type
    const handleClick = isDisabled 
        ? undefined 
        : (typeof props.onClick === 'function' ? props.onClick : () => {});
    
    return (
        <button 
            className='secondary'
            disabled={isDisabled}
            onClick={handleClick}
            {...(props.extraOptions || {})}
        >
            <span>{props.label ? props.label : (<LanguageStringResolver string='manualDocumentsButton_manualDocuments' />)}</span>
        </button> 
    );
}

export default ManualDocumentsButton;
